<script setup>
import { computed } from 'vue';

const emit = defineEmits(['selectSuggestion']);

const props = defineProps({
	suggestions: Object,
	filterValue: String,
})

const filteredData = computed(() => {
	return !props.filterValue ?
		props.suggestions.values :
		props.suggestions.values?.filter(el => el.title.toLowerCase().includes(props.filterValue.toLowerCase()));
})
</script>

<template>
	<div class="suggestions-wr">
		<div class="suggestions__header">
			{{ suggestions.title }}
		</div>
		<ul class="suggestions__content">
			<li>
				<button
					class="suggestions__btn"
					@click="emit('selectSuggestion', { title: suggestions.emptyValue })"
				>
					{{ suggestions.emptyValue }}
				</button>
			</li>
			<li
				v-for="item in filteredData"
				:key="item.id"
			>
				<button
					class="suggestions__btn"
					@click="emit('selectSuggestion', {
						title : item.title,
						id    : item.id
					})"
				>
					{{ item.title }}
				</button>
			</li>
		</ul>
	</div>
</template>

<style lang='scss'>
	.suggestions-wr {
		width: 100%;
		position: absolute;
		left: 0;
		margin-top: 4px;
		z-index: 10;
		background-color: #FAFAFA;
		border-radius: 12px;
		overflow: hidden;
		box-shadow: 0 4px 20px 0 #00000026;
	}

	.suggestions__header {
		padding: 15.5px 16px;
		font-family: "Raleway";
		font-weight: 600;
		font-size: 16px;
	}

	.suggestions__content {
		height: 100%;
		max-height: 360px;
		overflow-y: scroll;
		display: flex;
		flex-direction: column;
		background-color: #FFF;
	}

	.suggestions__btn {
		width: 100%;
		text-align: left;
		padding: 21px 16px;
		border-bottom: 1px solid #D9D9D9
	}
</style>